import React, { useState } from"react";
import { Link, useNavigate } from"react-router-dom";
import globals from"../Globals";
import axios from"axios";

const API = globals.API;

// Form field component to reduce repetition
const FormField = ({ label, type ="text", value, onChange, placeholder, disabled, required = false, style = {} }) => (
 <div style={style}>
 <label style={{ fontWeight: '500', fontSize: '14px', marginBottom: '8px', color: '#e5e7eb', display: 'block' }}>
 {label}
 </label>
 <input
 type={type}
 placeholder={placeholder}
 value={value}
 onChange={onChange}
 disabled={disabled}
 required={required}
 style={{
 padding: '12px 16px',
 border: '1px solid #374151',
 borderRadius: '8px',
 fontSize: '15px',
 width: '100%',
 backgroundColor: '#252540',
 color: 'white',
 outline: 'none',
 boxSizing: 'border-box'
 }}
 />
 </div>
);

function Login() {
 const [isSignup, setIsSignup] = useState(false);
 const [email, setEmail] = useState("");
 const [password, setPassword] = useState("");
 const [firstName, setFirstName] = useState("");
 const [lastName, setLastName] = useState("");
 const [showPassword, setShowPassword] = useState(false);
 const [termsAccepted, setTermsAccepted] = useState(false);
 const [error, setError] = useState("");
 const [loading, setLoading] = useState(false);
 const navigate = useNavigate();

 // Extended form fields
 const [formData, setFormData] = useState({
 raisonSociale:"",
 capitalSocial:"",
 personneSignataire:"",
 fonctionSignataire:"",
 adresse:"",
 ville:"",
 telephone:"",
 emailContact:"",
 nomPremierResponsable:"",
 fonctionPremierResponsable:"",
 mobilePremierResponsable:"",
 personneContact:"",
 fonctionContact:"",
 mobileContact:"",
 finance:"",
 mobileFinance:"",
 emailFinance:"",
 dateCreation:"",
 agrement:"",
 numeroIATA:"",
 rc:"",
 patente:""
 });

 const updateField = (field, value) => {
 setFormData(prev => ({ ...prev, [field]: value }));
 };

 const resetForm = () => {
 setFirstName("");
 setLastName("");
 setEmail("");
 setPassword("");
 setTermsAccepted(false);
 setFormData({
 raisonSociale:"",
 capitalSocial:"",
 personneSignataire:"",
 fonctionSignataire:"",
 adresse:"",
 ville:"",
 telephone:"",
 emailContact:"",
 nomPremierResponsable:"",
 fonctionPremierResponsable:"",
 mobilePremierResponsable:"",
 personneContact:"",
 fonctionContact:"",
 mobileContact:"",
 finance:"",
 mobileFinance:"",
 emailFinance:"",
 dateCreation:"",
 agrement:"",
 numeroIATA:"",
 rc:"",
 patente:""
 });
 };

 const handleLogin = async (e) => {
 e.preventDefault();
 setError("");
 setLoading(true);

 try {
 const res = await axios.post(`${API}/users/login`, { email, password });
 const { token, user } = res.data;

 localStorage.setItem("authToken", token);
 localStorage.setItem("user", JSON.stringify(user));

 if (user.role ==="admin") {
 navigate("/dashboard");
 } else {
 navigate("/b2b");
 }
 } catch (err) {
 console.error(err);
 setError(err.response?.data?.message ||"Erreur de connexion. Veuillez réessayer.");
 } finally {
 setLoading(false);
 }
 };

 const handleSignup = async (e) => {
 e.preventDefault();
 setError("");

 if (!termsAccepted) {
 setError("Veuillez accepter les termes et conditions.");
 return;
 }

 setLoading(true);

 try {
 await axios.post(`${API}/users/register`, {
 name: `${firstName} ${lastName}`,
 email,
 phoneNumber: formData.telephone,
 role:"other",
 ...formData,
 dateCreation: formData.dateCreation || undefined
 });

 alert("Demande d'inscription soumise avec succès. En attente d'approbation de l'administrateur.");
 resetForm();
 setIsSignup(false);
 } catch (err) {
 console.error(err);
 setError(err.response?.data?.message ||"Erreur d'inscription. Veuillez réessayer.");
 } finally {
 setLoading(false);
 }
 };

 return (
 <>
 <style>{`
 @keyframes float {
 0%, 100% { transform: translateY(0px); }
 50% { transform: translateY(-20px); }
 }

 * {
 box-sizing: border-box;
 }

 .scroll-container {
 max-height: calc(100vh - 120px);
 overflow-y: auto;
 padding-right: 10px;
 }

 .scroll-container::-webkit-scrollbar {
 width: 6px;
 }

 .scroll-container::-webkit-scrollbar-track {
 background: #1a1a2e;
 }

 .scroll-container::-webkit-scrollbar-thumb {
 background: #6366f1;
 border-radius: 3px;
 }

 /* ========================= */
 /* RESPONSIVE STYLES */
 /* ========================= */

 @media (max-width: 1024px) {
 .login-container {
 flex-direction: column !important;
 height: auto !important;
 min-height: 100vh !important;
 }

 .left-panel {
 width: 100% !important;
 min-height: 300px !important;
 padding: 40px 24px !important;
 flex: none !important;
 }

 .left-panel h2 {
 font-size: 28px !important;
 }

 .right-panel {
 width: 100% !important;
 max-width: 100% !important;
 padding: 40px 24px !important;
 flex: none !important;
 }

 .scroll-container {
 max-height: none !important;
 }
 }

 @media (max-width: 768px) {
 .login-container {
 overflow-y: auto !important;
 overflow-x: hidden !important;
 }

 .left-panel {
 min-height: 250px !important;
 padding: 32px 20px !important;
 }

 .left-panel h2 {
 font-size: 24px !important;
 }

 .left-panel p {
 font-size: 14px !important;
 }

 .right-panel {
 padding: 32px 20px !important;
 width: 100% !important;
 justify-content: flex-start !important;
 padding-top: 40px !important;
 }

 .scroll-container {
 max-height: none !important;
 padding-right: 0 !important;
 }

 .grid-2 {
 grid-template-columns: 1fr !important;
 }

 h1 {
 font-size: 26px !important;
 }

 h2 {
 font-size: 24px !important;
 }

 h3 {
 font-size: 15px !important;
 }

 h4 {
 font-size: 13px !important;
 }
 }

 @media (max-width: 480px) {
 .right-panel {
 padding: 24px 16px !important;
 }

 button {
 padding: 12px !important;
 font-size: 14px !important;
 }

 input {
 font-size: 14px !important;
 padding: 10px 14px !important;
 }

 label {
 font-size: 13px !important;
 }

 h1 {
 font-size: 24px !important;
 }

 .scroll-container {
 padding-right: 0 !important;
 }
 }

 @media (max-width: 360px) {
 .right-panel {
 padding: 20px 12px !important;
 }

 h1 {
 font-size: 22px !important;
 }

 input {
 font-size: 13px !important;
 padding: 9px 12px !important;
 }

 button {
 font-size: 13px !important;
 }
 }
`}</style>


 <div className="login-container" style={{
 display: 'flex',
 height: '100vh',
 width: '100%',
 fontFamily:"'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif"
 }}>
 {/* Left Panel - Branding */}
 <div className="left-panel" style={{
 flex: 1,
 // background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
 background: 'url("/assets/img/loginbg.jpg") no-repeat center center/cover',
 color: 'white',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 flexDirection: 'column',
 padding: '60px',
 position: 'relative',
 overflow: 'hidden'
 }}>
 <div style={{
 position: 'absolute',
 width: '300px',
 height: '300px',
 background: 'rgba(255, 255, 255, 0.1)',
 borderRadius: '50%',
 filter: 'blur(60px)',
 top: '80px',
 left: '80px',
 animation: 'float 6s ease-in-out infinite'
 }}></div>

 <div style={{ position: 'relative', zIndex: 10, textAlign: 'center', maxWidth: '500px' }}>
 <div style={{
 width: '256px',
 height: '256px',
 background: 'rgba(255, 255, 255, 0.2)',
 backdropFilter: 'blur(10px)',
 borderRadius: '20px',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 margin: '0 auto 32px'
 }}>
 <img src="/assets/img/logo1.png" alt="Logo" style={{ width: '230px', height: '230px', borderRadius: '14px', objectFit: 'contain' }} />
 </div>

 <h2 style={{ fontSize: '36px', marginBottom: '16px', fontWeight: '700' }}>
 Capturing Moments,<br />Creating Memories
 </h2>

 <p style={{ opacity: 0.9, fontSize: '16px', lineHeight: '1.6', marginTop: '16px' }}>
 Gérez votre agence de voyage avec des outils puissants.
 Surveillez les réservations & suivez les performances.
 </p>

 <Link to="/" style={{
 display: 'inline-flex',
 alignItems: 'center',
 gap: '8px',
 background: 'rgba(231, 231, 231, 0.2)',
 backdropFilter: 'blur(10px)',
 padding: '12px 24px',
 borderRadius: '8px',
 fontWeight: '500',
 textDecoration: 'none',
 color: 'grey',
 marginTop: '48px'
 }}>
 <svg style={{ width: '20px', height: '20px' ,color:'grey'}} fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
 </svg>
 Back to website
 </Link>
 </div>
 </div>

 {/* Right Panel - Form */}
 <div className="right-panel" style={{
 flex: 1,
 padding: '60px',
 display: 'flex',
 flexDirection: 'column',
 justifyContent: 'center',
 backgroundColor: '#454f5dff',
 // backgroundColor: '#1a1a2e',
 maxWidth: '600px',
 color: 'white'
 }}>
 <div style={{
 width: '48px',
 height: '48px',
 background: 'linear-gradient(135deg, #4748a5ff, #8b5cf6)',
 borderRadius: '12px',
 display: 'flex',
 alignItems: 'center',
 justifyContent: 'center',
 marginBottom: '32px'
 }}>
 <svg style={{ width: '28px', height: '28px' }} fill="none" stroke="currentColor" viewBox="0 0 24 24">
 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
 </svg>
 </div>

 <h1 style={{ fontSize: '32px', marginBottom: '8px', fontWeight: '700' ,color:'#e0e7ff'}}>
 {isSignup ?"Créer un compte" :"Bienvenue !"}
 </h1>

 <p style={{ color: '#9ca3af', marginBottom: '32px', fontSize: '15px' }}>
 {isSignup ? (
 <>
 Vous avez déjà un compte?{""}
 <span onClick={() => { setIsSignup(false); setError(""); }} style={{ color: '#6366f1', cursor: 'pointer', fontWeight: '500' }}>
 Se connecter
 </span>
 </>
 ) :"Connectez-vous pour accéder à votre tableau de bord."}
 </p>

 <div className="scroll-container">
 <form onSubmit={isSignup ? handleSignup : handleLogin}>
 {isSignup && (
 <>
 {/* Basic Info */}
 <div className="grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '20px' }}>
 <FormField label="Prénom" value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder="Prénom" disabled={loading} required />
 <FormField label="Nom" value={lastName} onChange={(e) => setLastName(e.target.value)} placeholder="Nom" disabled={loading} required />
 </div>

 {/* Company Section */}
 <div className="grid-2" style={{ backgroundColor: '#252540', padding: '20px', borderRadius: '12px', marginBottom: '20px', border: '1px solid #374151' }}>
 <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px' }}>Informations de l'entreprise</h3>
 <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
 <FormField label="Raison sociale" value={formData.raisonSociale} onChange={(e) => updateField('raisonSociale', e.target.value)} disabled={loading} />
 <FormField label="Capital social" value={formData.capitalSocial} onChange={(e) => updateField('capitalSocial', e.target.value)} disabled={loading} />
 </div>
 <div className="grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
 <FormField label="Personne signataire" value={formData.personneSignataire} onChange={(e) => updateField('personneSignataire', e.target.value)} disabled={loading} />
 <FormField label="Fonction" value={formData.fonctionSignataire} onChange={(e) => updateField('fonctionSignataire', e.target.value)} disabled={loading} />
 </div>
 </div>

 {/* Address Section */}
 <div style={{ backgroundColor: '#252540', padding: '20px', borderRadius: '12px', marginBottom: '20px', border: '1px solid #374151' }}>
 <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px' }}>Coordonnées</h3>
 <FormField label="Adresse" value={formData.adresse} onChange={(e) => updateField('adresse', e.target.value)} disabled={loading} style={{ marginBottom: '16px' }} />
 <div className="grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
 <FormField label="Ville" value={formData.ville} onChange={(e) => updateField('ville', e.target.value)} disabled={loading} />
 <FormField label="Téléphone" type="tel" value={formData.telephone} onChange={(e) => updateField('telephone', e.target.value)} disabled={loading} />
 </div>
 <FormField label="Email de contact" type="email" value={formData.emailContact} onChange={(e) => updateField('emailContact', e.target.value)} disabled={loading} />
 </div>

 {/* Contacts Section */}
 <div style={{ backgroundColor: '#252540', padding: '20px', borderRadius: '12px', marginBottom: '20px', border: '1px solid #374151' }}>
 <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px' }}>Personnes de contact</h3>
 
 <h4 style={{ fontSize: '14px', fontWeight: '500', marginBottom: '12px', color: '#9ca3af' }}>1er Responsable</h4>
 <div className="grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
 <FormField label="Nom" value={formData.nomPremierResponsable} onChange={(e) => updateField('nomPremierResponsable', e.target.value)} disabled={loading} />
 <FormField label="Fonction" value={formData.fonctionPremierResponsable} onChange={(e) => updateField('fonctionPremierResponsable', e.target.value)} disabled={loading} />
 </div>
 <FormField label="Mobile" type="tel" value={formData.mobilePremierResponsable} onChange={(e) => updateField('mobilePremierResponsable', e.target.value)} disabled={loading} style={{ marginBottom: '20px' }} />

 <h4 style={{ fontSize: '14px', fontWeight: '500', marginBottom: '12px', color: '#9ca3af' }}>Personne de contact</h4>
 <div className="grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
 <FormField label="Nom" value={formData.personneContact} onChange={(e) => updateField('personneContact', e.target.value)} disabled={loading} />
 <FormField label="Fonction" value={formData.fonctionContact} onChange={(e) => updateField('fonctionContact', e.target.value)} disabled={loading} />
 </div>
 <FormField label="Mobile" type="tel" value={formData.mobileContact} onChange={(e) => updateField('mobileContact', e.target.value)} disabled={loading} style={{ marginBottom: '20px' }} />

 <h4 style={{ fontSize: '14px', fontWeight: '500', marginBottom: '12px', color: '#9ca3af' }}>Contact Finance</h4>
 <div className="grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
 <FormField label="Nom" value={formData.finance} onChange={(e) => updateField('finance', e.target.value)} disabled={loading} />
 <FormField label="Mobile" type="tel" value={formData.mobileFinance} onChange={(e) => updateField('mobileFinance', e.target.value)} disabled={loading} />
 </div>
 <FormField label="Email" type="email" value={formData.emailFinance} onChange={(e) => updateField('emailFinance', e.target.value)} disabled={loading} />
 </div>

 {/* Legal Info Section */}
 <div style={{ backgroundColor: '#252540', padding: '20px', borderRadius: '12px', marginBottom: '20px', border: '1px solid #374151' }}>
 <h3 style={{ fontSize: '16px', fontWeight: '600', marginBottom: '16px' }}>Informations légales</h3>
 <div className="grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
 <FormField label="Date de création" type="date" value={formData.dateCreation} onChange={(e) => updateField('dateCreation', e.target.value)} disabled={loading} />
 <FormField label="Agrément (Licence)" value={formData.agrement} onChange={(e) => updateField('agrement', e.target.value)} disabled={loading} />
 </div>
 <div className="grid-2" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
 <FormField label="N° IATA" value={formData.numeroIATA} onChange={(e) => updateField('numeroIATA', e.target.value)} disabled={loading} />
 <FormField label="RC" value={formData.rc} onChange={(e) => updateField('rc', e.target.value)} disabled={loading} />
 </div>
 <FormField label="Patente" value={formData.patente} onChange={(e) => updateField('patente', e.target.value)} disabled={loading} />
 </div>

 <div style={{ backgroundColor: '#1e293b', border: '1px solid #334155', borderRadius: '8px', padding: '12px 16px', marginBottom: '20px', display: 'flex', gap: '10px' }}>
 <svg style={{ width: '20px', height: '20px', color: '#60a5fa', flexShrink: 0 }} fill="currentColor" viewBox="0 0 20 20">
 <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd" />
 </svg>
 <div style={{ fontSize: '13px', color: '#cbd5e1' }}>
 Votre demande sera examinée par un administrateur. Vous recevrez vos identifiants par email une fois approuvé.
 </div>
 </div>
 </>
 )}

 {/* Email field */}
 <FormField 
 label={isSignup ?"Email" :"Adresse Email"} 
 type="email" 
 value={email} 
 onChange={(e) => setEmail(e.target.value)} 
 placeholder={isSignup ?"votre.email@exemple.com" :"Entrez votre email"} 
 disabled={loading} 
 required 
 style={{ marginBottom: '20px' }} 
 />

 {/* Password field (login only) */}
 {!isSignup && (
 <div style={{ marginBottom: '20px' }}>
 <label style={{ fontWeight: '500', fontSize: '14px', marginBottom: '8px', color: '#e5e7eb', display: 'block' }}>Mot de passe</label>
 <div style={{ position: 'relative' }}>
 <input
 type={showPassword ?"text" :"password"}
 placeholder="Entrez votre mot de passe"
 value={password}
 onChange={(e) => setPassword(e.target.value)}
 disabled={loading}
 required
 style={{
 padding: '12px 16px',
 paddingRight: '45px',
 border: '1px solid #374151',
 borderRadius: '8px',
 fontSize: '15px',
 width: '100%',
 backgroundColor: '#252540',
 color: 'white'
 }}
 />
 <span onClick={() => setShowPassword(!showPassword)} style={{ position: 'absolute', right: '14px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', fontSize: '20px' }}>
 {showPassword ?"🙈" :"👁️"}
 </span>
 </div>
 </div>
 )}

 {/* Terms checkbox (signup only) */}
 {isSignup && (
 <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px' }}>
 <input
 type="checkbox"
 id="terms"
 checked={termsAccepted}
 onChange={(e) => setTermsAccepted(e.target.checked)}
 style={{ width: '18px', height: '18px', cursor: 'pointer', accentColor: '#6366f1' }}
 />
 <label htmlFor="terms" style={{ fontSize: '14px', color: '#9ca3af', cursor: 'pointer' }}>
 I agree to the <span style={{ color: '#6366f1', textDecoration: 'underline' }}>Terms & Conditions</span>
 </label>
 </div>
 )}

 {/* Error message */}
 {error && (
 <div style={{
 display: 'flex',
 alignItems: 'center',
 gap: '8px',
 backgroundColor: '#7f1d1d',
 color: '#fca5a5',
 padding: '12px 16px',
 borderRadius: '8px',
 fontSize: '14px',
 marginBottom: '20px',
 border: '1px solid #991b1b'
 }}>
 <svg style={{ width: '16px', height: '16px' }} fill="currentColor" viewBox="0 0 20 20">
 <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
 </svg>
 {error}
 </div>
 )}

 {/* Submit button */}
 <button
 type="submit"
 disabled={loading}
 style={{
 background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
 color: 'white',
 border: 'none',
 borderRadius: '8px',
 padding: '14px',
 fontWeight: '600',
 fontSize: '15px',
 cursor: loading ? 'not-allowed' : 'pointer',
 boxShadow: '0 4px 6px -1px rgba(99, 102, 241, 0.2)',
 opacity: loading ? 0.6 : 1,
 width: '100%'
 }}
 >
 {loading ? (isSignup ?"Envoi en cours..." :"Connexion...") : (isSignup ?"Soumettre la demande" :"Sign in")}
 </button>

 {/* Switch between login/signup */}
 {!isSignup && (
 <div style={{ textAlign: 'center', marginTop: '24px', fontSize: '14px', color: '#6b7280' }}>
 Pas de compte?{""}
 <span onClick={() => { setIsSignup(true); setError(""); }} style={{ color: '#6366f1', fontWeight: '500', cursor: 'pointer' }}>
 S'inscrire
 </span>
 </div>
 )}
 </form>
 </div>
 </div>
 </div>
 </>
 );
}

export default Login;